module.exports = __webpack_public_path__ + "img/w39b.db81a5b5.jpg";